var render = function render(_c,_vm){return _c(_vm.$options.components.Rating,{tag:"component",staticClass:"card-rating",attrs:{"read-only":true,"rating-style":_vm.props.field.style,"color":_vm.props.field.color,"value":_vm.props.value,"max-value":_vm.props.field.max_value}})
}
var staticRenderFns = []

export { render, staticRenderFns }